import { render, staticRenderFns } from "./sys-tabs.vue?vue&type=template&id=9f841868"
import script from "./sys-tabs.vue?vue&type=script&lang=js"
export * from "./sys-tabs.vue?vue&type=script&lang=js"
import style0 from "./sys-tabs.vue?vue&type=style&index=0&id=9f841868&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports